module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods-swip-wrapper"
  }, [_c('div', {
    staticClass: "ads-wrapper"
  }, [_c('div', {
    staticClass: "goods-type-title"
  }, [_c('div', {
    staticClass: "goods-type-title-left"
  }, [_c('div', {
    staticClass: "left-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "right-sub"
  }, [_vm._v(_vm._s(_vm.subTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "goods-type-title-right",
    on: {
      "click": _vm.gotoMore
    }
  }, [_c('span', [_vm._v("更多")]), _c('img', {
    attrs: {
      "src": require("../../../assets//images/right.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "goods-item",
      on: {
        "click": function($event) {
          return _vm.gotoPage(item)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail || item.imgUrl,
        "atl": item.name || item.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-content-footer",
      style: ({
        background: _vm.isShowBg ? '#f8ebe4' : ''
      })
    }, [_c('div', {
      staticClass: "tit"
    }, [_vm._v(_vm._s(item.name || item.title))]), _vm._v(" "), _c('div', {
      staticClass: "pri"
    }, [_c('span', {
      staticClass: "pri-1"
    }, [_vm._v("￥" + _vm._s(item.mktprice))]), _c('span', {
      staticClass: "pri-2"
    }, [_vm._v("会员价")]), _c('span', {
      staticClass: "pri-3"
    }, [_vm._v("￥" + _vm._s(item.price))])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c7b91dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/banner-square/goodsList.vue
// module id = 1561
// module chunks = 1